module.exports = __webpack_public_path__ + "static/media/create_entity.956393cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/create_entity.png
// module id = 228
// module chunks = 0